import { render, staticRenderFns } from "./BubbleNews.vue?vue&type=template&id=427d2065&scoped=true&"
import script from "./BubbleNews.vue?vue&type=script&lang=js&"
export * from "./BubbleNews.vue?vue&type=script&lang=js&"
import style0 from "./BubbleNews.vue?vue&type=style&index=0&id=427d2065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d2065",
  null
  
)

export default component.exports